import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation updateRegistrationFormWaiver(
    $formId: Int!
    $id: Int!
    $title: String!
    $content: String!
    $signatureType: String!
    $active: Boolean
    $filename: String
    $originalFileName: String
  ) {
    updateRegistrationFormWaiver(
      id: $id
      formId: $formId
      title: $title
      content: $content
      signatureType: $signatureType
      active: $active
      filename: $filename
      originalFileName: $originalFileName
    ) {
      formId
      id
      title
      content
      signatureType
      active
      filename
      originalFileName
    }
  }
`;
